module.exports = __webpack_public_path__ + "static/media/WhiteLogo.d515b5d0.svg";